var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "p",
    { staticClass: "d-flex align-items-center green-color fs-12 fw-600 my-2" },
    [
      _c("span", { staticStyle: { width: "30px" } }, [
        _c("img", {
          attrs: { alt: "check_label", src: `/images/${_vm.icon}.svg` },
        }),
      ]),
      _c(
        "router-link",
        {
          staticClass: "system_link-style",
          attrs: { exact: "", target: "_blank", to: _vm.to },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }